import React, { useEffect, useState } from 'react';
import { Button, Table, Image } from 'react-bootstrap';

/* import custom hook function */
import usePagination from '../hook/model/usePagination';

/* import context function */
import { PaginationProvider } from '../context/pageContext';

import Pagination from '../components/pagination';

export const Header = ({ content }) => (
    <thead>
        <tr>
            {
                content?.map(({ key, value }, index) => (
                    <th key={`${key}-${index}`}>{ value }</th>
                ))
            }
        </tr>
    </thead>
);

export const Body = ({ content, colspan }) => (
    <tbody>
            {
                content.length ? content :
                <tr><td className='text-center' colSpan={ colspan }>尚無資料</td></tr>
            }
    </tbody>
);

export const TableList = ({ tarage, content, idKey, action }) => {
    
    return (
        <tr>
            {
                tarage.map(({key, value}, index) => {
                    let _value = content[key];
                    
                    if (key === 'delete')
                        _value = <Button type='button' variant='danger' onClick={ () => action.delete(content[idKey]) }>Remove</Button>

                    else if (key === 'photo') {
                        const photoImage = content?.photo || content?.oldMonsterPhoto || (content?.newMonsterPhoto && URL.createObjectURL(content?.newMonsterPhoto));

                        _value = <Image className='image' src={ photoImage } />
                    }

                    return (
                        <td key={ key }>{ _value }</td>
                    )
                })
            }
        </tr>
    );
};

const ModelTable = ({ header = [], body = [], idKey, totalCount, action, quantity = 5 }) => {
    const [pagination, setPagination] = usePagination({ quantity });
    const [bodyContent, setBodyContent] = useState([]);
    
    useEffect(() => {
        if (body.length) {
            const { skip, top } = pagination;
            const limit = body.length >= (skip + top) ? (skip + top) : body.length;
            const _content = [];

            for(let i = skip; i < limit; i++) {
                const element = <TableList key={ body[i][idKey] } tarage={ header } content={ body[i] } action={ action } idKey={ idKey } />;

                _content.push(element);
            }

            setBodyContent(_content);
        }
        else setBodyContent(body);
    }, [body, pagination]);

    return (
        <PaginationProvider pagination={{ condition: pagination, setPagination }}>
            <div className="model-table-container">
                <Table striped className='text-center' hover>
                    <Header content={ header } />
                    <Body content={ bodyContent } colspan={ header.length } />
                </Table>
                <Pagination totalCount={ totalCount } />
            </div>
        </PaginationProvider>
    )
};

export default React.memo(ModelTable);